import { render, staticRenderFns } from "./SelectedDestination.vue?vue&type=template&id=0b090db4&scoped=true"
import script from "./SelectedDestination.vue?vue&type=script&lang=ts"
export * from "./SelectedDestination.vue?vue&type=script&lang=ts"
import style0 from "./SelectedDestination.vue?vue&type=style&index=0&id=0b090db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b090db4",
  null
  
)

export default component.exports